import { getLocale } from "./i18n.svelte.js";

const BASE = "";

let token = $state(localStorage.getItem("snapshot_token") || "");

window.addEventListener("storage", (e) => {
  if (e.key === "snapshot_token") {
    token = e.newValue || "";
  }
});

export function setToken(t) {
  token = t;
  if (t) {
    localStorage.setItem("snapshot_token", t);
  } else {
    localStorage.removeItem("snapshot_token");
  }
}

export function getToken() {
  return token;
}

async function request(method, path, body = null) {
  const headers = {
    "Accept-Language": getLocale(),
  };

  if (token) {
    headers["Authorization"] = `Bearer ${token}`;
  }

  if (body !== null && !(body instanceof FormData)) {
    headers["Content-Type"] = "application/json";
  }

  const opts = { method, headers };
  if (body !== null) {
    opts.body = body instanceof FormData ? body : JSON.stringify(body);
  }

  const res = await fetch(`${BASE}${path}`, opts);

  if (res.status === 401) {
    setToken("");
    window.location.hash = "#/login";
    throw new Error("Unauthorized");
  }

  const data = await res.json().catch(() => null);

  if (!res.ok) {
    const msg = data?.error || `Request failed (${res.status})`;
    throw new Error(msg);
  }

  return data;
}

export const api = {
  get: (path) => request("GET", path),
  post: (path, body) => request("POST", path, body),
  put: (path, body) => request("PUT", path, body),
  patch: (path, body) => request("PATCH", path, body),
  del: (path) => request("DELETE", path),
};
